import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import logo from '../../assets/imagens/logo.png';
import { useGoogleAdsDetection } from '../../utils/useGoogleAdsDetection';
import './header.scss';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const isFromGoogleAds = useGoogleAdsDetection();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Não renderizar header se for tráfego do Google Ads
  if (isFromGoogleAds) {
    return null;
  }

  return (
    <motion.header 
      className={`header ${isScrolled ? 'scrolled' : ''}`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="container">
        <div className="header-content">
          <a href="/" className="logo">
            <img src={logo} alt="Eco Lavanderia Express" />
          </a>

          {/* Menu removido para landing page de tráfego pago - otimização conversão */}

          {/* <button onClick={handleWhatsApp} className="whatsapp-btn">
            <i className="ri-whatsapp-line"></i>
            <span>WhatsApp</span>
          </button> */}

          {/* Menu mobile removido para landing page de tráfego pago */}
        </div>
      </div>
    </motion.header>
  );
}